import React, { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    // Back/forward (POP) keeps its position; pages restore their own scroll.
    if (navigationType === "POP") return;
    window.scrollTo(0, 0);
  }, [location, navigationType]);
  return <>{children}</>;
};

export default ScrollToTop;
